import { Divider, Popconfirm, Row, Space, Steps, Typography } from 'antd'
import styles from './index.module.less'
import { render } from 'react-dom'
import { CloseOutlined } from '@ant-design/icons'
import TreeSearchTable from './components/treeSearchTable'
import { useState } from 'react'
import { KeepAlive } from 'react-activation';

export default function ProductManage(props) {
  const { isShowGuide= true} = props
  const description = 'This is a description.'
  const [leadGuideShow, setLeadGuideShow] = useState(true)
  const clickToClose = () => {
    setLeadGuideShow(false)
  }
  return (
    <KeepAlive name={location.pathname}>
      <div className={styles.baseBox}>
        {isShowGuide && leadGuideShow && (
          <div className={styles.leadBox}>
            {/* 快速导航 */}
            <p className={styles.leadTitle}>如何快速在线销售？</p>
            <Steps
              className={styles.leadSteps}
              current={-1}
              size="small"
              items={[
                {
                  title: '基础设置',
                  description: (
                    <div>
                      <Row style={{ fontSize: '10px' }}>
                        <span>产品分类</span>
                        <Divider type="vertical"></Divider>
                        <span>项目管理</span>
                        <Divider type="vertical"></Divider>
                        <span>通项管理</span>
                      </Row>
                      <Row style={{ fontSize: '10px' }}>
                        <span>参数管理</span>
                        <Divider type="vertical"></Divider>
                        <span>费用项管理</span>
                        <Divider type="vertical"></Divider>
                        <span>品牌管理</span>
                        <Divider type="vertical"></Divider>
                        <span>单位管理</span>
                      </Row>
                    </div>
                  ),
                },
                {
                  title: '打包模板配置&价格策略',
                  description: (
                    <div>
                      <Row style={{ fontSize: '10px' }}>
                        <span>子项管理</span>
                        <Divider type="vertical"></Divider>
                        <span>打包模板</span>
                        <Divider type="vertical"></Divider>
                        <span>价格策略</span>
                      </Row>
                    </div>
                  ),
                },
                {
                  title: '产品管理:新建产品并发布',
                  description: (
                    <div>
                      <Row style={{ fontSize: '10px' }}>
                        <span>新建产品、发布产品</span>
                      </Row>
                    </div>
                  ),
                },
                {
                  title: '商品管理:新增商品/商品上架',
                  description: (
                    <div>
                      <Row style={{ fontSize: '10px' }}>
                        <span>销售配置、上架</span>
                      </Row>
                    </div>
                  ),
                },
              ]}
            />
            <Popconfirm
              title="确认关闭引导?"
              description=""
              onConfirm={clickToClose}
              onCancel={() => {
                null
              }}
              okText="确认"
              cancelText="取消"
            >
              <CloseOutlined className={styles.closeIcon} />
            </Popconfirm>
          </div>
        )}

        {/* 表格 */}
        <TreeSearchTable {...props}/>
      </div>
    </KeepAlive>
  )
}
